import { Modal } from "antd";
import React from "react";

export const OFFLINE_PAYMENT_DISCLAIMER_TEXT =
  "Hay2U operates solely as a market forum and assumes no liability for cash or cheque transactions. All payments are conducted solely between the buyer and seller at their own risk.";

// See TODO-046 Q1 for why Cheque is not included.
export const OFFLINE_PAYMENT_METHOD_IDS: ReadonlySet<number> = new Set([5]);

interface OfflinePaymentDisclaimerModalProps {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

const OfflinePaymentDisclaimerModal: React.FC<
  OfflinePaymentDisclaimerModalProps
> = ({ open, onAccept, onCancel }) => (
  <Modal
    open={open}
    okText="Accept"
    cancelText="Cancel"
    onOk={onAccept}
    onCancel={onCancel}
    keyboard
    maskClosable
  >
    <p>{OFFLINE_PAYMENT_DISCLAIMER_TEXT}</p>
  </Modal>
);

export default OfflinePaymentDisclaimerModal;
